import { isOngoingReservationStatus } from '@iheartjane/types';

import { createUseQueryHook } from '../createUseQueryHook';
import type {
  GuestReservationDetailsProps,
  ReservationDetailsProps,
  ReservationsProps,
} from './reservations.api';
import {
  fetchGuestReservationDetails,
  fetchReservationDetails,
  fetchReservations,
} from './reservations.api';
import type {
  CustomerReservationDetails,
  CustomerReservationHistory,
  GuestCustomerReservationDetails,
} from './reservations.types';
import { RESERVATIONS_BASE_KEY } from './reservations.utils';

const fetchInProgressReservations = async (props: ReservationsProps) => {
  const reservations = await fetchReservations(props);

  return reservations.filter((reservation) =>
    isOngoingReservationStatus(reservation.status)
  );
};

const reservationsKeys = {
  reservations: ({ storeId }: ReservationsProps) => [
    RESERVATIONS_BASE_KEY,
    storeId,
  ],
  reservationsInProgress: ({ storeId }: ReservationsProps) => [
    RESERVATIONS_BASE_KEY,
    'in_progress',
    storeId,
  ],
  reservationDetails: ({ id }: ReservationDetailsProps) => [
    RESERVATIONS_BASE_KEY,
    id,
  ],
  guestReservationDetails: ({ id }: GuestReservationDetailsProps) => [
    RESERVATIONS_BASE_KEY,
    'guest',
    id,
  ],
  // notifyCurbsideArrival: ({ id }: ReservationRequestProps) => [
  //   RESERVATIONS_BASE_KEY,
  //   'curbside_arrival',
  //   id,
  // ],
};

export const useReservations = createUseQueryHook<
  ReservationsProps,
  CustomerReservationHistory[]
>(fetchReservations, reservationsKeys.reservations, ({ enabled }) => !!enabled);

export const useInProgressReservations = createUseQueryHook<
  ReservationsProps,
  CustomerReservationHistory[]
>(
  fetchInProgressReservations,
  reservationsKeys.reservationsInProgress,
  ({ enabled }) => !!enabled
);

export const useReservationDetails = createUseQueryHook<
  ReservationDetailsProps,
  CustomerReservationDetails
>(
  fetchReservationDetails,
  reservationsKeys.reservationDetails,
  ({ id }) => !!id
);

export const useGuestReservationDetails = createUseQueryHook<
  GuestReservationDetailsProps,
  GuestCustomerReservationDetails
>(
  fetchGuestReservationDetails,
  reservationsKeys.guestReservationDetails,
  ({ id }) => !!id
);
